<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-veggiesbonanza">
      <div class="px-3 col-3 p-0">
        <div class="heading-veggiesbonanza">{{ $t("result.round") }}</div>
        <div class="text-subhead-veggiesbonanza">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-veggiesbonanza">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-veggiesbonanza">
          {{ (data.bet) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-veggiesbonanza">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-veggiesbonanza">
          {{ (data.winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-veggiesbonanza">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-veggiesbonanza">
          {{ (data.balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-veggiesbonanza pt-3">
      <div class="text-games-veggiesbonanza">{{ "Veggies Bonanza" }}</div>
      <div class="text-subgame-veggiesbonanza">{{ $t("veggiesbonanza.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp  }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0 align-items-center" style="margin-top: 40px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="state === 'FREESPIN' || state === 'FREERESPIN' || state === 'RESPIN'"
            class="fas fa-caret-left arrow-side-veggiesbonanza" @click="delCount()" />
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-center">
            <img v-if="data.detail.winnings.length > 0" class="d-flex col-8 mb-4"
              :src="require(`../../assets/resultGame/veggiesbonanza/win.png`)" alt="" />
            <img v-else class="d-flex col-8 mb-4" :src="require(`../../assets/resultGame/veggiesbonanza/lose.png`)"
              alt="" />
          </div>
          <div class="table-veggiesbonanza d-flex flex-row slot-container">
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.reels[0]" :key="index">
                <div style=" position: relative;text-align: center; ">
                  <img class="icon-symbol-veggiesbonanza"
                    :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${reel}.png`)" alt="" />
                  <div v-if="reel === 10" class="multiplier-text">x{{ multiplierReel[0][index] }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.reels[1]" :key="index">
                <div style=" position: relative;text-align: center; ">
                  <img class="icon-symbol-veggiesbonanza"
                    :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${reel}.png`)" alt="" />
                  <div v-if="reel === 10" class="multiplier-text">x{{ multiplierReel[1][index] }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.reels[2]" :key="index">
                <div style=" position: relative;text-align: center; ">
                  <img class="icon-symbol-veggiesbonanza"
                    :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${reel}.png`)" alt="" />
                  <div v-if="reel === 10" class="multiplier-text">x{{ multiplierReel[2][index] }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in this.reels[3]" :key="index">
                <div style=" position: relative;text-align: center; ">
                  <img class="icon-symbol-veggiesbonanza"
                    :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${reel}.png`)" alt="" />
                  <div v-if="reel === 10" class="multiplier-text">x{{ multiplierReel[3][index] }}</div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(reel, index) in this.reels[4]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-veggiesbonanza"
                      :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${reel}.png`)" alt="" />
                    <div v-if="reel === 10" class="multiplier-text">x{{ multiplierReel[4][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(reel, index) in this.reels[5]" :key="index">
                  <div style=" position: relative;text-align: center; ">
                    <img class="icon-symbol-veggiesbonanza"
                      :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${reel}.png`)" alt="" />
                    <div v-if="reel === 10" class="multiplier-text">x{{ multiplierReel[5][index] }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!data.detail.isEndRound" class="fas fa-caret-right arrow-side-veggiesbonanza"
            @click="addCount()"></i>
        </div>
      </div>

      <div class="text-center py-4 text-games-veggiesbonanza">
        <h1 v-if="state === 'FREESPIN'"> FREESPIN {{ data.detail.freeSpin.round }}/{{ data.detail.freeSpin.remain }}
        </h1>
        <h1 v-else-if="state === 'FREERESPIN'"> FREESPIN {{ data.detail.freeSpin.round }}/{{ data.detail.freeSpin.remain
          }} (RESPIN) </h1>
        <h1 v-else-if="state === 'SPIN'"> SPIN {{ data.detail.round }}/{{ data.detail.page }} </h1>
        <h1 v-else-if="state === 'RESPIN'"> RESPIN {{ data.detail.round }}/{{ data.detail.page }} </h1>
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-veggiesbonanza"> Feature Buy </div>
      <div
        v-if="data.detail.winnings.length > 0 || state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
        class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3"> {{ $t("result.detail") }} </div>
        <hr class="line col-3" />
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div v-if="state === 'FREERESPIN' && (nextState === 'FREESPIN' || nextState === '-')"
          class="col-12 multiplier-box-veggiesbonanza align-items-center">
          <h1 class="my-1 green">{{ $t("veggiesbonanza.multiplier.title") }} x{{ this.multiplier }}</h1>
          <h1 class="my-1 green"> {{ $t("veggiesbonanza.totalwin") }}
            {{ ((data.detail.win / this.multiplier)) | currencyFormatter }}
            x {{ this.multiplier }}
            = {{ (data.detail.win) | currencyFormatter }}</h1>
        </div>
      </div>
      <div v-if="!!data.detail.winnings && data.detail.winnings.length > 0"
        class="col-12 justify-content-start d-flex flex-row">
        <div class=" bet-box-veggiesbonanza p-2 px-3 justify-content-start align-items-center container">

          <div class="bet-wrapper justify-content-between item d-flex col-12"
            v-for="(detail, index) in data.detail.winnings" :key="index">
            <div class="d-flex flex-row">
              <img class="icon-detail-veggiesbonanza"
                :src="require(`../../assets/resultGame/veggiesbonanza/symbol_${detail.symbol}.png`)" alt="" />
              <div class="d-flex text-win align-items-center justify-content-center">
                <p class="my-1 green">{{ ` ${detail.count} ` + $t("result.kind") }}</p>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-3">
              <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-veggiesbonanza",
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      multiplierReel: this.data.detail.multiplierReels ? this.data.detail.multiplierReels : null,
      state: "SPIN",
      multiplier: 0,
      reels: [],
    };
  },
  async created() {
    await this.mapSymbol();
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName(
        "header-veggiesbonanza"
      )[0].offsetHeight;
    },
    async mapSymbol() {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.state = this.data.detail.state;
      this.nextState = this.data.detail.nextState;
      this.reels = this.data.detail.reels;
      if (this.state === 'SPIN' || this.state === 'RESPIN')
        this.multiplier = this.data.detail.multiplier;
      else
        this.multiplier = this.data.detail.multiplier;

      if (this.data.detail.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      const countData = this.data.count + 1;
      this.$emit("fetchResult", countData);
      await this.mapSymbol();
    },
    async delCount() {
      const countData = this.data.count - 1;
      this.$emit("fetchResult", countData);
      await this.mapSymbol();
    },
  },
};
</script>
<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  margin: 0;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.text-win {
  height: 144px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-veggiesbonanza {
  width: 140px;
  height: 144px;
  padding: 4px;
}

.icon-bonus-veggiesbonanza {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-veggiesbonanza {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-veggiesbonanza {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.multiplier-box-veggiesbonanza {
  /* background: #0c161f; */
  border-radius: 10px;
  min-height: 50px;
  max-height: 100px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 800px;
}

.bonus-box-veggiesbonanza {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-veggiesbonanza .item {
  color: #fff;
  /* background: #06112d; */
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-veggiesbonanza .bet-wrapper-veggiesbonanza:not(:first-child) .item {
  margin-top: 10px;
  /* width: 800px; */
}

.bet-wrapper-veggiesbonanza,
.result-wrapper {
  font-size: 35px;
  /* width: 800px; */
}

.header-veggiesbonanza {
  background: #A7CC2D;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-veggiesbonanza>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-veggiesbonanza {
  color: #000000;
  text-align: center;
}

.content-result-veggiesbonanza {
  background: #432615;
  height: 180vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-veggiesbonanza {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-veggiesbonanza {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-veggiesbonanza {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-veggiesbonanza {
  font-size: 20px;
  color: #ffd500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-veggiesbonanza {
  position: relative;
  width: 100%;
  /* padding: 5%; */
}

.bet-box-veggiesbonanza {
  min-width: 600px;
  max-width: auto;
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-108px, 0px);
}

.icon-symbol.-level1 {
  width: 109px;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 109px;
  height: 176px;
}

.icon-symbol.-level3 {
  width: 109px;
  height: 266px;
}

.icon-symbol.-level4 {
  width: 112px;
  height: 352px;
}

.table-veggiesbonanza {
  background: url("~@/assets/resultGame/veggiesbonanza/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 920px 800px;
  /* set Bg Table HERE */
  width: 920px;
  height: 800px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 200px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -157px);
}

.slot-container {
  position: relative;
  align-items: center;
}

.multiplier-container {
  width: 100%;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 689px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-veggiesbonanza {
    background-size: 649px 600px;
    width: 649px;
    height: 600px;
    transform: translate(0px, -114px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-veggiesbonanza {
    min-width: 580px;
    max-width: auto;
    height: 100%;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-126px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 104px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 209px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 314px;
  }

  .icon-symbol.-level4 {
    width: 127px;
    height: 419px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-veggiesbonanza,
  .result-wrapper {
    font-size: 33px;
    /* width: 800px; */
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-127px, 0px);
  }

  .icon-symbol.-level1 {
    width: 127px;
    height: 105px;
  }

  .icon-symbol.-level2 {
    width: 126px;
    height: 210px;
  }

  .icon-symbol.-level3 {
    width: 127px;
    height: 315px;
  }

  .icon-symbol.-level4 {
    width: 126px;
    height: 419px;
  }
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 35px;
}

.win-box {
  width: 689px;
}

@media screen and (max-width: 770px) {
  .heading-veggiesbonanza {
    font-size: 18px;
  }

  .table-veggiesbonanza {
    background-size: 638px 164px;
    width: 638px;
    height: 268px;
    margin-bottom: 1%;
    transform: translate(0px, -121px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-veggiesbonanza {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-veggiesbonanza {
    min-width: 430px;
    max-width: auto;
    height: 100%;
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .top-reel {
    width: 67%;
    transform: translate(104px, 0px);
  }

  .win-box {
    width: 689px;
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }

  .multiplier-container {
    width: 80%;
  }

  .text-multiplier {
    width: 505px;
    text-align: center;
  }

  .green {
    font-size: 40px;
  }
}

@media screen and (max-width: 800px) {
  .table-veggiesbonanza {
    background-size: 664px 600px;
    width: 664px;
    height: 600px;
    transform: translate(0px, -108px);
  }

  .top-reel {
    width: 67%;
    transform: translate(111px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-111px, 0px);
  }

  .icon-symbol.-level1 {
    width: 110px;
    height: 92px;
  }

  .icon-symbol.-level2 {
    width: 111px;
    height: 183px;
  }

  .icon-symbol.-level3 {
    width: 111px;
    height: 275px;
  }

  .icon-symbol.-level4 {
    width: 111px;
    height: 367px;
  }
}

@media screen and (max-width: 780px) {
  .top-reel {
    display: flex;
    flex-direction: row;
    position: relative;
    width: 67%;
    transform: translate(105px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-107px, 0px);
  }

  .icon-symbol.-level1 {
    width: 107px;
    height: 89px;
  }

  .icon-symbol.-level2 {
    width: 107px;
    height: 177px;
  }

  .icon-symbol.-level3 {
    width: 107px;
    height: 264px;
  }

  .icon-symbol.-level4 {
    width: 106px;
    height: 352px;
  }
}

@media screen and (max-width: 600px) {
  .table-veggiesbonanza {
    background-size: 498px 460px;
    width: 498px;
    height: 460px;
    transform: translate(0px, -93px);
  }

  .top-reel {
    width: 67%;
    transform: translate(82px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-83px, 0px);
  }

  .icon-symbol.-level1 {
    width: 83px;
    height: 70px;
  }

  .icon-symbol.-level2 {
    width: 83px;
    height: 138px;
  }

  .icon-symbol.-level3 {
    width: 83px;
    height: 207px;
  }

  .icon-symbol.-level4 {
    width: 83px;
    height: 275px;
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-veggiesbonanza>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-veggiesbonanza {
    font-size: 12px;
  }

  .table-veggiesbonanza {
    background-size: 375px 340px;
    width: 375px;
    height: 340px;
    transform: translate(0px, -93px);
  }

  .text-subhead-veggiesbonanza {
    font-size: 14px;
  }

  .bet-box-veggiesbonanza {
    min-width: 230px;
    max-width: auto;
    height: 100%;
  }

  .bonus-box-veggiesbonanza {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-veggiesbonanza,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-veggiesbonanza {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-veggiesbonanza {
    width: 60px;
    height: 60px;
  }

  .top-reel {
    width: 67%;
    transform: translate(62px, 0px);
  }

  .icon-symbol {
    position: absolute;
    transform: translate(-63px, 0px);
  }

  .icon-symbol.-level1 {
    width: 63px;
    height: 52px;
  }

  .icon-symbol.-level2 {
    width: 63px;
    height: 104px;
  }

  .icon-symbol.-level3 {
    width: 63px;
    height: 155px;
  }

  .icon-symbol.-level4 {
    width: 63px;
    height: 207px;
  }

  .green {
    font-size: 18px;
  }

  .text-win {
    height: 57px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }

  .win-box {
    width: 760px;
  }

  .green {
    font-size: 19px;
  }
}

.multiplier-text {
  font-size: 8vw;
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  font-weight: 500;
}
</style>
